var _rect, _g, _g2, _g3, _rect2, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWceIdonotWallToWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 212,
    height: 232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M187.2,228.5v-5.3h3.5v0.6h-2.8v1.7h2.8v0.6h-2.8v2.4H187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.5,228.5v-5.3h0.7v4.7h2.5v0.6H191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M195.6,227.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S195.8,227.7,195.6,227.3z M196,225.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C196.2,224.7,196,225.2,196,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M201.7,227.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S202,227.7,201.7,227.3z M202.1,225.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C202.3,224.7,202.1,225.2,202.1,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M207.8,228.5v-5.3h2.1c0.5,0,0.9,0.1,1.2,0.4s0.5,0.7,0.5,1.2c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1l1.4,2.2h-0.8l-1.4-2.1h-1.1v2.1H207.8z  M208.4,225.8h1.4c0.3,0,0.6-0.1,0.8-0.3s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7s-0.5-0.3-0.8-0.3h-1.4V225.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 178.5,
    y1: 40,
    x2: 5.8,
    y2: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "177.4,36.4 183.6,40 177.4,43.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "6.9,36.4 0.6,40 6.9,43.6  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.6,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.6,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1036,
    width: 184.3,
    height: 224.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M186.4,7.1c-0.1-0.3-0.2-0.7-0.2-1.1s0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.5-0.9s0.5-0.4,0.8-0.6 s0.6-0.2,1-0.2c0.8,0,1.4,0.4,1.8,1.1L190,4.6c-0.1-0.2-0.3-0.4-0.6-0.6c-0.2-0.1-0.5-0.2-0.8-0.2c-0.5,0-1,0.2-1.3,0.6 s-0.5,0.9-0.5,1.6c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,0.9,0.3c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.6-0.6 l0.5,0.3c-0.5,0.7-1.1,1.1-1.8,1.1c-0.3,0-0.7-0.1-1-0.2s-0.6-0.3-0.8-0.6S186.5,7.5,186.4,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.3,8.7V3.3h3.1v0.6h-2.5v1.7h2.5v0.6h-2.5v1.8h2.5v0.6H191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M195.3,8.7V3.3h0.6v5.3H195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M197,8.7V3.3h0.6v4.7h2.2v0.6H197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200.6,8.7V3.3h0.6v5.3H200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M202.3,8.7V3.3h0.6l2.8,4.2V3.3h0.6v5.3h-0.6l-2.8-4.3v4.3H202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M207.4,7.1c-0.1-0.3-0.2-0.7-0.2-1.1s0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.2,0.5-0.4,0.8-0.6 c0.3-0.1,0.6-0.2,1-0.2c0.8,0,1.4,0.3,1.9,1l-0.5,0.3c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2-0.1-0.5-0.2-0.8-0.2c-0.5,0-1,0.2-1.3,0.6 c-0.4,0.4-0.5,0.9-0.5,1.6c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.1,0.4-0.2,0.6-0.4V6.5h-1.6V5.9h2.2v1.9c-0.2,0.3-0.5,0.5-0.8,0.7s-0.7,0.2-1.1,0.2c-0.3,0-0.7-0.1-1-0.2 c-0.3-0.1-0.6-0.3-0.8-0.6C207.7,7.8,207.6,7.5,207.4,7.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWceIdonotWallToWall);
export default __webpack_public_path__ + "static/media/WCE-IDONOT-WallToWall.cf4411c22ef5d9a84cbfcdd780e13973.svg";
export { ForwardRef as ReactComponent };